import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, switchLanguage, LANGUAGES } = useLanguage();

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <button
        onClick={() => switchLanguage(LANGUAGES.FR)}
        className={`px-2 py-1 text-sm font-medium rounded transition-colors ${
          language === LANGUAGES.FR
            ? 'bg-teal-500 text-white'
            : 'text-slate-600 hover:text-teal-600 hover:bg-slate-100'
        }`}
        aria-label="Français"
      >
        FR
      </button>
      <span className="text-slate-300">|</span>
      <button
        onClick={() => switchLanguage(LANGUAGES.EN)}
        className={`px-2 py-1 text-sm font-medium rounded transition-colors ${
          language === LANGUAGES.EN
            ? 'bg-teal-500 text-white'
            : 'text-slate-600 hover:text-teal-600 hover:bg-slate-100'
        }`}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
